import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

const ModalMakePaymentForClientPlotsForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
  const [plotNumberPOP, setPlotNumberPOP] = useState("");
  const [datePOPPlots, setDatePOPPlots] = useState("");
  const [amountPOPPlots, setAmountPOPPlots] = useState("");
  const [POPPlots, setPOPPlots] = useState(null);
  const [companyID, setCompanyID] = useState("");
  const [businessLocationID, setBusinessLocationID] = useState("");
  //const [apiType] = useState("uploadPOPPlots");

  const [isFormValid, setIsFormValid] = useState(false);
  const [plotOptions, setPlotOptions] = useState([]);

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getPOPPlotsOnUploadForm');
    formData.append("businessLocationID", businessLocationID);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setPlotOptions(response.data);
      })
      .catch(error => {
        //alert('There was an error fetching the plots!', error);
      });
  }, [companyID, businessLocationID]);

  useEffect(() => {
    // Check if all form fields are filled to enable the submit button
    setIsFormValid(plotNumberPOP && datePOPPlots && amountPOPPlots && POPPlots);
  }, [plotNumberPOP, datePOPPlots, amountPOPPlots, POPPlots]);

  const handleInputChange = (e) => {
    const { id, value, files } = e.target;
    if (id === "POPPlots") {
      setPOPPlots(files[0]);
    } else {
      switch (id) {
        case "plotNumberPOP":
          setPlotNumberPOP(value);
          break;
        case "datePOPPlots":
          setDatePOPPlots(value);
          break;
        case "amountPOPPlots":
          setAmountPOPPlots(value);
          break;
        case "companyID":
          setCompanyID(value);
          break;
        case "businessLocationID":
          setBusinessLocationID(value);
          break;
        default:
          break;
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("plotNumberPOP", plotNumberPOP);
    formData.append("datePOPPlots", datePOPPlots);
    formData.append("amountPOPPlots", amountPOPPlots);
    formData.append("POPPlots", POPPlots);
    formData.append("companyID", companyID);
    formData.append("businessLocationID", businessLocationID);
    formData.append("apiType", 'uploadPOPPlots');

    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        alert(response.data);
        setPlotNumberPOP("");
        setDatePOPPlots("");
        setAmountPOPPlots("");
        setPOPPlots(null);
        setCompanyID("");
        setBusinessLocationID("");
      })
      .catch(error => {
        //console.error('There was an error uploading the data!', error);
        alert('Error: Please Check Your Internet Connection. If This Persists, Kindly Contact Support Team');
      });
  };

  return (
    <>
    <main className='bg-white'>
    <Header />
    <hr />
    <div className="  mt-5" id="modalMakePaymentForClientPlotsForm" >
       
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Upload Proof Of Payment For Plots</p>
           
          </div>
          <div className="modal-body">
            <form id="fileUploadFormPOPPlots" onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row">
                <div className="col-lg-12 col-md-12 mb-4 text-left">
                  <label htmlFor="plotNumberPOP">Plot Number</label>
                  <select className="custom-select d-block w-100" id="plotNumberPOP" name="plotNumberPOP" value={plotNumberPOP} onChange={handleInputChange}>
                    <option value="">Choose...</option>
                    {plotOptions.map(option => (
                      <option key={option.plotsID} value={option.plotsID}>
                        Plot Number = {option.plotNumber} @ ZMK{option.plotPrice}, Customer = {option.customersNameDB}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-3 col-md-12 mb-2 text-left">
                  <div className="md-outline">
                    <label htmlFor="datePOPPlots">Date</label>
                    <input type="date" className="form-control" id="datePOPPlots" name="datePOPPlots" value={datePOPPlots} onChange={(e) => setDatePOPPlots(e.target.value)} />
                  </div>
                </div>
                <div className="col-lg-3 col-md-12 mb-2 text-left">
                  <div className="md-outline">
                    <label htmlFor="amountPOPPlots">Amount</label>
                    <input type="text" className="form-control" id="amountPOPPlots" name="amountPOPPlots" value={amountPOPPlots} onChange={(e) => setAmountPOPPlots(e.target.value)} />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 mb-2 text-left">
                  <div className="md-outline">
                    <label htmlFor="POPPlots">Proof Of Payment</label>
                    <input type="file" className="form-control" id="POPPlots" name="POPPlots" onChange={handleInputChange} />
                  </div>
                  <input type="hidden" id="companyID" name="companyID" value={companyID} onChange={(e) => setCompanyID(e.target.value)} />
                  <input type="hidden" id="businessLocationID" name="businessLocationID" value={businessLocationID} onChange={(e) => setBusinessLocationID(e.target.value)} />
                  <input type="hidden" id="apiType" name="apiType" value="uploadPOPPlots" />
                </div>
              </div>
              <div className="text-center mt-0">
                <button type="submit" className="btn btn-success" id="uploadPOPPlots" disabled={!isFormValid}>
                  Upload POP <i className="fas fa-coins ml-1"></i>
                </button>
              </div>
            </form>
          </div>
          <div className="modal-footer">
           
          </div>
        </div>
      </div>
    </div>
    </main>
    </>
  );
};

export default ModalMakePaymentForClientPlotsForm;
